import { Icon } from "@iconify/react/dist/iconify.js";
import { ActionIcon } from "@mantine/core";
import { useEffect, useState } from "react";

import useBreakPoint from "~/lib/use-break-point";

export default function ChatwootButton() {
  const [ready, setReady] = useState(false);
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    setHydrated(true);
    const interval = setInterval(() => {
      setReady(true);
      clearInterval(interval);
    }, 300);
    return () => clearInterval(interval);
  }, []);
  const isMobile = useBreakPoint("sm");

  // SSR: Don't render button until after hydration, avoids prop mismatch
  if (!hydrated) return null;

  const handleShowChat = () => {
    window.$chatwoot.toggle();
  };

  const message = [
    "Halo Tim Customer Service,",
    "Saya membutuhkan bantuan terkait penggunaan aplikasi. Mohon bantuan dan arahannya.",
    "Terima kasih.",
  ].join("\n");

  const url = `https://wa.me/62811341214?text=${encodeURIComponent(message)}`;

  return (
    <ActionIcon
      variant="gradient"
      className="rounded-full"
      aria-label="Gradient action icon"
      gradient={{ from: "#E03131", to: "#FF6B6B", deg: 180 }}
      size={isMobile ? 32 : "xl"}
      radius={"xl"}
      disabled={!ready}
      component="a"
      href={url}
      target="_blank"
      // onClick={handleShowChat}
    >
      <Icon icon="tabler:headset" className="h-6 w-6" />
    </ActionIcon>
  );
}
